// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3fG-e","selected":"Chip_selected__25hLw"};